exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".basicSiteHeader{min-height:5rem;background-color:#fff;color:#00a0f4}.basicSiteHeader .headerContainer{text-align:center;padding:1rem 1.5rem}.basicSiteHeader .centerNav,.basicSiteHeader .leftNav,.basicSiteHeader .rightNav{display:inline-block;vertical-align:center}.basicSiteHeader .leftNav,.basicSiteHeader .rightNav{width:25%}.basicSiteHeader .leftNav{text-align:left;font-size:.8em}.basicSiteHeader .centerNav{width:50%}@media(max-width:45rem){.basicSiteHeader .centerNav .wrLogo{width:100%}}@media(min-width:45rem)and (max-width:75rem){.basicSiteHeader .centerNav .wrLogo{width:60%}}@media(min-width:75rem){.basicSiteHeader .centerNav .wrLogo{width:30%}}.basicSiteHeader .rightNav{text-align:left}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./assets/sass/layout/basic_site_header.scss
// module id = 1306
// module chunks = 0